export default {
    title: '나의 과제',
    hero: {
        bgAlt: '놀이공원 배경',
        panelAlt: '나의 과제 타이틀 패널',
        title: '나의 과제',
        description: '선생님이 내주신 과제를 확인하고<br/>하나씩 차근차근 진행해 보세요.',
    },
    aria: {
        boardLabel: '과제 보드',
        tabsLabel: '과제 상태 탭',
        progress: '과제 진행률 {percent}%',
        actionButton: '{title} {label}',
    },
    tabs: {
        active: '진행중인 과제',
        ended: '마감된 과제',
    },
    meta: {
        activityCount: '활동 수',
        createdAt: '생성일',
        endedAt: '종료일',
    },
    status: {
        before: '진행 전',
        inprogress: '진행 중',
        complete: '완료',
        endedComplete: '완료',
        endedIncomplete: '미완료',
    },
    actions: {
        view: '과제 보기',
        studyComplete: '학습 완료',
        viewResult: '결과 보기',
    },
    stamp: {
        alt: '학습 완료 도장',
    },
    empty: {
        active: '진행중인 과제가 없어요.',
        ended: '마감된 과제가 없어요.',
    },
    activity: {
        name: '활동 {index}',
    },
    modal: {
        closeAria: '모달 닫기',
        close: '닫기',
        start: '시작하기',
    },
    flash: {
        title: {
            info: '안내',
            warning: '주의',
            error: '오류',
        },
        confirm: '확인',
    },
};
